import { FormGroup, ValidatorFn } from '@angular/forms';

export const passwordMatchValidator: ValidatorFn = (formGroup: FormGroup) => {
  const pass1 = formGroup.get('pass1');
  const pass2 = formGroup.get('pass2');

  if (!pass1 || !pass2) {
    return null;
  }

  const errors: any = {};

  if (!pass1.value) {
    errors.pass1Required = true;
  }

  if (!pass2.value) {
    errors.pass2Required = true;
  }

  if (pass1.value && pass2.value && pass1.value !== pass2.value) {
    errors.passwordMismatch = true;
  }

  return Object.keys(errors).length ? errors : null;
};